<template>
  <div>
    <v-col v-if="!tieneDatosGrafica" cols="12">
      <v-alert color="blue-grey" text class="mb-0">
        <div class="text-center" style="font-size: 16px">
          No hay datos para mostrar
        </div>
      </v-alert>
    </v-col>
    <v-col v-else cols="12">
      <v-col col="12">
        <v-row v-if="showSideKpis" dense>
          <!-- Teóricas -->
          <v-col cols="3">
            <v-card outlined class="pa-4 fill-height d-flex flex-column">
              <div class="d-flex align-center mb-3">
                <span class="text-uppercase caption grey--text text--darken-1 font-weight-medium mb-4">
                  PIEZAS ESPERADAS
                </span>
                <v-spacer></v-spacer>
              </div>

              <v-row no-gutters class="flex-grow-1" justify="center" align="center">
                <template v-if="modo === 'dias'">
                  <div class="d-flex flex-column align-center">
                    <div class="d-flex align-center justify-center mb-1">
                      <div class="kpi-icon mr-2" :style="{ background: coloresClaros[0] }">
                        <v-icon size="20" :color="paletteBars[0]">mdi-target-variant</v-icon>
                      </div>
                      <div class="kpi-number" :style="{ color: paletteBars[0] }">
                        {{ nf(kpisActuales.esperadas) }}
                      </div>
                    </div>
                    <div class="kpi-sub text-center mt-3">Total del periodo</div>
                  </div>
                </template>
                <!-- caso original (horas / cavidades / artículos) -->
                <template v-else>
                  <template v-if="!loading">
                    <template v-if="ladosEsperadas && ladosEsperadas.length">
                      <v-col v-for="(lado, idx) in ladosEsperadas" :key="'esp-' + idx"
                        :cols="ladosEsperadas.length === 1 ? 'auto' : 6"
                        :offset="(ladosEsperadas.length > 1 && ladosEsperadas.length % 2 === 1 && idx === ladosEsperadas.length - 1) ? 3 : 0"
                        class="d-flex justify-center px-0">
                        <div class="d-flex flex-column align-center">
                          <div class="d-flex align-center justify-center mb-1">
                            <div class="kpi-icon mr-2"
                              :style="{ background: coloresClaros[idx % coloresClaros.length] }">
                              <v-icon size="20"
                                :color="paletteBars[idx % paletteBars.length]">mdi-target-variant</v-icon>
                            </div>
                            <div class="kpi-number" :style="{ color: paletteBars[idx % paletteBars.length] }">
                              {{ Math.round(lado.valor) }}
                            </div>
                          </div>
                          <div class="kpi-sub text-center mt-3" style="line-height: 15px;">{{ lado.cavidad || '' }}
                          </div>
                        </div>
                      </v-col>
                    </template>
                    <v-col v-else class="d-flex justify-center align-center text-subtitle-2">
                      Sin Datos
                    </v-col>
                  </template>
                </template>

                <v-col v-else cols="12" class="d-flex justify-center align-center">
                  <v-progress-circular indeterminate :color="paletteBars[0]" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- PIEZAS TOTALES DEL TURNO -->
          <v-col cols="3">
            <v-card outlined class="pa-4 fill-height d-flex flex-column">
              <div class="d-flex align-center mb-3">
                <span class="text-uppercase caption grey--text text--darken-1 font-weight-medium mb-4">PIEZAS
                  OK</span>
                <v-spacer></v-spacer>
              </div>

              <v-row no-gutters class="flex-grow-1" justify="center">
                <template v-if="modo === 'dias'">
                  <div class="d-flex flex-column align-center">
                    <div class="d-flex align-center justify-center mb-1">
                      <div class="kpi-icon mr-2" :style="{ background: coloresClaros[0] }">
                        <v-icon size="20" :color="paletteBars[0]">mdi-target-variant</v-icon>
                      </div>
                      <div class="kpi-number" :style="{ color: paletteBars[0] }">
                        {{ nf(kpisActuales.ok) }}
                      </div>
                    </div>
                    <div class="kpi-sub text-center mt-3">Total del periodo</div>
                  </div>
                </template>
                <template v-else>
                  <template v-if="!loading">
                    <template v-if="lados && lados.length">
                      <v-col v-for="(lado, idx) in lados" :key="idx" cols="6">
                        <div class="d-flex flex-column align-center">
                          <div class="d-flex align-center justify-center mb-1">
                            <div class="kpi-icon mr-2"
                              :style="{ background: coloresClaros[idx % coloresClaros.length] }">
                              <v-icon size="20" :color="paletteBars[idx % paletteBars.length]">
                                mdi-trending-up
                              </v-icon>
                            </div>
                            <div class="kpi-number" :style="{ color: paletteBars[idx % paletteBars.length] }">
                              {{ lado.valor || '-' }}
                            </div>
                          </div>
                          <div v-if="mostrarSiempreNombreArt" class="kpi-sub text-center mt-3"
                            style="line-height: 15px;">
                            {{ lado.cavidad || '' }}</div>
                          <div v-else>
                            <div v-if="agruparPor == 'cavidades'" class="kpi-sub text-center mt-3"
                              style="line-height: 15px;">
                              {{ lado.token || '' }} -
                              <v-tooltip top color="black">
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    {{ (lado.articulos && lado.articulos.length) || 0 }} Artículo(s)
                                  </span>
                                </template>

                                <div class="py-2 px-3">
                                  <template v-if="lado.articulos && lado.articulos.length">
                                    <ul class="ma-0 pa-0" style="list-style: none;">
                                      <li v-for="(art, i) in lado.articulos" :key="i" class="white--text">
                                        {{ (art && typeof art === 'object')
                                          ? (art.nombre || art.descripcion || art.codigo || art.clave || art.sku ||
                                            'Artículo')
                                          : art }}
                                      </li>
                                    </ul>
                                  </template>
                                  <span class="white--text" v-else>Sin artículos</span>
                                </div>
                              </v-tooltip>
                            </div>
                            <div v-else class="kpi-sub text-center mt-3" style="line-height: 15px;">
                              {{ lado.cavidad || "" }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </template>
                    <v-col v-else class="d-flex justify-center align-center text-subtitle-2">
                      Sin Datos
                    </v-col>
                  </template>
                </template>

                <v-col v-else cols="12" class="d-flex justify-center align-center">
                  <v-progress-circular indeterminate :color="paletteBars[0]" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- SCRAP TOTAL -->
          <v-col cols="3">
            <v-card outlined class="pa-4 fill-height d-flex flex-column">
              <div class="d-flex align-center mb-3">
                <span class="text-uppercase caption grey--text text--darken-1 font-weight-medium mb-4">
                  PIEZAS NO OK
                </span>
                <v-spacer></v-spacer>
              </div>

              <v-row no-gutters class="flex-grow-1" justify="center" align="center">
                <template v-if="modo === 'dias'">
                  <div class="d-flex flex-column align-center">
                    <div class="d-flex align-center justify-center mb-1">
                      <div class="kpi-icon mr-2" :style="{ background: coloresClaros[0] }">
                        <v-icon size="20" :color="paletteBars[0]">mdi-target-variant</v-icon>
                      </div>
                      <div class="kpi-number" :style="{ color: paletteBars[0] }">
                        {{ nf(kpisActuales.noOk) }}
                      </div>
                    </div>
                    <div class="kpi-sub text-center mt-3">Total del periodo</div>
                  </div>
                </template>
                <template v-else>
                  <template v-if="!loading">
                    <template v-if="ladosNoOk && ladosNoOk.length">
                      <v-col v-for="(lado, idx) in ladosNoOk" :key="'nok-' + idx"
                        :cols="ladosNoOk.length === 1 ? 'auto' : 6"
                        :offset="(ladosNoOk.length > 1 && ladosNoOk.length % 2 === 1 && idx === ladosNoOk.length - 1) ? 3 : 0"
                        class="d-flex justify-center px-0">
                        <div class="d-flex flex-column align-center">
                          <div class="d-flex align-center justify-center mb-1">
                            <div class="kpi-icon mr-2" :style="{ background: errorBg }">
                              <v-icon size="20" :color="error">mdi-delete</v-icon>
                            </div>
                            <div class="d-flex align-end">
                              <div class="kpi-number error--text">
                                {{ Math.round(lado.valor) }}
                              </div>
                              <div v-if="lado.okBruto != null" class="kpi-suffix grey--text text--darken-1">
                                / {{ Math.round(lado.okBruto) }}
                              </div>
                            </div>
                          </div>
                          <div v-if="mostrarSiempreNombreArt" class="kpi-sub text-center mt-3"
                            style="line-height: 15px;">
                            {{ lado.cavidad || '' }}</div>
                          <div v-else>
                            <div v-if="agruparPor == 'cavidades'" class="kpi-sub text-center mt-3"
                              style="line-height: 15px;">
                              {{ lado.token || '' }} -
                              <v-tooltip top color="black">
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    {{ (lado.articulos && lado.articulos.length) || 0 }} Artículo(s)
                                  </span>
                                </template>

                                <div class="py-2 px-3">
                                  <template v-if="lado.articulos && lado.articulos.length">
                                    <ul class="ma-0 pa-0" style="list-style: none;">
                                      <li v-for="(art, i) in lado.articulos" :key="i" class="white--text">
                                        {{ (art && typeof art === 'object')
                                          ? (art.nombre || art.descripcion || art.codigo || art.clave || art.sku ||
                                            'Artículo')
                                          : art }}
                                      </li>
                                    </ul>
                                  </template>
                                  <span class="white--text" v-else>Sin artículos</span>
                                </div>
                              </v-tooltip>
                            </div>
                            <div v-else class="kpi-sub text-center mt-3" style="line-height: 15px;">
                              {{ lado.cavidad || "" }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </template>
                    <v-col v-else class="d-flex justify-center align-center text-subtitle-2">
                      Sin Datos
                    </v-col>
                  </template>
                </template>

                <v-col v-else cols="12" class="d-flex justify-center align-center">
                  <v-progress-circular indeterminate :color="paletteBars[0]" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- DELTA -->
          <v-col cols="3">
            <v-card outlined class="pa-4 fill-height d-flex flex-column">
              <div class="d-flex align-center mb-3">
                <span class="text-uppercase caption grey--text text--darken-1 font-weight-medium mb-4">
                  DIFERENCIA (Pzas Ok + NO ok contra esperadas)
                </span>
                <v-spacer></v-spacer>
              </div>

              <v-row no-gutters class="flex-grow-1" justify="center" align="center">
                <template v-if="modo === 'dias'">
                  <div class="d-flex flex-column align-center">
                    <div class="d-flex align-center justify-center mb-1">
                      <div class="kpi-icon mr-2" :style="{ background: coloresClaros[0] }">
                        <v-icon size="20" :color="paletteBars[0]">mdi-target-variant</v-icon>
                      </div>
                      <div class="kpi-number" :style="{ color: paletteBars[0] }">
                        {{ nf(kpisActuales.delta) }}
                      </div>
                    </div>
                    <div class="kpi-sub text-center mt-3">Total del periodo</div>
                  </div>
                </template>

                <template v-else>
                  <template v-if="!loading">
                    <template v-if="ladosDelta && ladosDelta.length">
                      <v-col v-for="(lado, idx) in ladosDelta" :key="'delta-' + idx"
                        :cols="ladosDelta.length === 1 ? 'auto' : 6"
                        :offset="(ladosDelta.length > 1 && ladosDelta.length % 2 === 1 && idx === ladosDelta.length - 1) ? 3 : 0"
                        class="d-flex justify-center px-0">
                        <div class="d-flex flex-column align-center">
                          <div class="d-flex align-center justify-center mb-1">
                            <div class="kpi-icon mr-2" :style="{ background: lado.valor >= 0 ? successBg : errorBg }">
                              <v-icon size="20" :color="lado.valor >= 0 ? success : error">
                                mdi-sigma-lower
                              </v-icon>
                            </div>
                            <div class="kpi-number" :class="lado.valor < 0 ? 'error--text' : ''"
                              :style="lado.valor >= 0 ? { color: success } : { color: error }">
                              {{ Math.round(Number(lado.valor)) }}
                            </div>

                          </div>
                          <div v-if="mostrarSiempreNombreArt" class="kpi-sub text-center mt-3"
                            style="line-height: 15px;">
                            {{ lado.cavidad || '' }}</div>
                          <div v-else>
                            <div v-if="agruparPor == 'cavidades'" class="kpi-sub text-center mt-3"
                              style="line-height: 15px;">
                              {{ lado.token || '' }} -
                              <v-tooltip top color="black">
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                    {{ (lado.articulos && lado.articulos.length) || 0 }} Artículo(s)
                                  </span>
                                </template>

                                <div class="py-2 px-3">
                                  <template v-if="lado.articulos && lado.articulos.length">
                                    <ul class="ma-0 pa-0" style="list-style: none;">
                                      <li v-for="(art, i) in lado.articulos" :key="i" class="white--text">
                                        {{ (art && typeof art === 'object')
                                          ? (art.nombre || art.descripcion || art.codigo || art.clave || art.sku ||
                                            'Artículo')
                                          : art }}
                                      </li>
                                    </ul>
                                  </template>
                                  <span class="white--text" v-else>Sin artículos</span>
                                </div>
                              </v-tooltip>
                            </div>
                            <div v-else class="kpi-sub text-center mt-3" style="line-height: 15px;">
                              {{ lado.cavidad || "" }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </template>
                    <v-col v-else class="d-flex justify-center align-center text-subtitle-2">
                      Sin Datos
                    </v-col>
                  </template>
                </template>

                <v-col v-else cols="12" class="d-flex justify-center align-center">
                  <v-progress-circular indeterminate :color="paletteBars[0]" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col
            :cols="12"
            :xs="12"
            :sm="12"
            :md="showSideKpis ? 8 : 12"
            :lg="showSideKpis ? 8 : 12"
            :xl="showSideKpis ? 8 : 12"
          >
            <apexchart ref="hhChart" :key="modo === 'dias'
              ? 'dias-' + (_categoriasX || []).join('|')
              : 'horas-' + (_horasCategorias || []).join('|')" type="line" height="500" :options="horaHoraOpts"
              :series="horaHoraSeries" />
          </v-col>
          <v-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
            <v-row v-if="showSideKpis">
              <v-col cols="12">
              <v-row align="stretch">
                <!-- TC QAD -->
                <v-col cols="6" class="d-flex">
                  <v-card elevation="1" class="flex-grow-1 d-flex flex-column">
                    <v-card-title class="areas-text areas-text no-split d-flex align-center">
                      <v-icon small color="green" class="mr-2">mdi-clock-outline</v-icon>
                      <span>TC QAD</span>
                    </v-card-title>
                    <v-card-text 
                      class="text-h5 font-weight-bold d-flex justify-center align-center"
                      style="color: #4CAF50;"
                    >
                      {{ tcProgramadoTxt }}
                    </v-card-text>
                  </v-card>
                </v-col>
                  <!-- <v-col cols="6" class="d-flex">
                    <v-card elevation="1" class="pa-4 d-flex justify-center align-center flex-grow-1">
                      <p v-if="_operacionesODT.length" class="areas-text mt-2">
                        {{ areasTexto }}
                      </p>
                    </v-card>
                  </v-col> -->

                    <v-col cols="6" class="d-flex">
                      <v-card 
                        elevation="1" 
                        class="flex-grow-1 d-flex flex-column clickable-card"
                        @click="dialogHistoricoTC = true"
                      >
                        <v-card-title class="areas-text no-split d-flex align-center">
                          <v-icon 
                            small 
                            color="amber" 
                            class="mr-2"
                            :class="{ 'pulse-icon': response.tcReal && response.tcReal.segundos > 0 }"
                          >
                            mdi-timer-outline
                          </v-icon>
                          <span>TC Real</span>
                          <v-spacer></v-spacer>
                          <v-icon small color="grey">mdi-chart-line</v-icon>
                        </v-card-title>
                        <v-card-text 
                          class="text-h5 font-weight-bold d-flex justify-center align-center"
                          style="color: #FFC107;"
                        >
                          {{ tcRealPromedioPonderadoSegHoraTxt }}
                        </v-card-text>
                      </v-card>
                    </v-col>

                  <HistoricoTCGrafica
                    v-model="dialogHistoricoTC"
                    :id-maquina-ins="idMaquinaIns"
                    :fecha="fecha"
                    :turno="turnoSeleccionado"
                    :maquina-nombre="maquinaSeleccionadaNombre"
                    :tc-programado="tcProgramadoSegPza"
                    :tc-real-actual="tcRealPromedioPonderadoSegHora"
                  />

              </v-row>

              </v-col>
              <v-col cols="6">
                <v-card class="pa-4" elevation="1">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[0]" size="36" class="mr-3">
                      <v-icon color="white">mdi-chart-bar-stacked</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">
                        OEE
                      </div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        <span v-if="tieneActividad">
                          {{ pf(kpisActuales.oee) }}
                        </span>
                        <span v-else>
                          Sin Datos
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="pa-4" elevation="1" @click="verParos(1)">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[1]" size="36" class="mr-3">
                      <v-icon color="white">mdi-clock-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">
                        Disponibilidad
                      </div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        <span v-if="tieneActividad">
                          {{ pf(kpisActuales.disp) }}
                        </span>
                        <span v-else>
                          Sin Datos
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="pa-4" elevation="1">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[2]" size="36" class="mr-3">
                      <v-icon color="white">mdi-run</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">
                        Eficiencia
                      </div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        <span v-if="tieneActividad">
                          {{ pf(kpisActuales.rend) }}
                        </span>
                        <span v-else>
                          Sin Datos
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="pa-4" elevation="1" @click="verNoOk()">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[3]" size="36" class="mr-3">
                      <v-icon color="white">mdi-star-circle-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">
                        Calidad
                      </div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                          <span v-if="tieneActividad">
                            {{ pf(kpisActuales.cali) }}
                          </span>
                          <span v-else>
                            Sin Datos
                          </span>
                        </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card class="pa-4" elevation="1" style="border-radius:12px;">
                  <div class="d-flex align-center mb-2">
                    <div class="mr-3"
                      style="width:36px;height:36px;border-radius:50%;background:#C82A54;color:white;display:flex;align-items:center;justify-content:center;">
                      <v-icon small color="white">mdi-chart-bar</v-icon>
                    </div>
                    <div>
                      <div class="text-subtitle-2">Tiempo de paro programado</div>
                      <div class="">
                        {{ partesDesdeSegundos(kpisActuales.segParoProg).h }} :
                        {{ partesDesdeSegundos(kpisActuales.segParoProg).m }} :
                        {{ partesDesdeSegundos(kpisActuales.segParoProg).s }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card class="pa-4" elevation="1" style="border-radius:12px;">
                  <div class="d-flex align-center mb-2">
                    <div class="mr-3"
                      style="width:36px;height:36px;border-radius:50%;background:#C82A54;color:white;display:flex;align-items:center;justify-content:center;">
                      <v-icon small color="white">mdi-timer-outline</v-icon>
                    </div>
                    <div>
                      <div class="text-subtitle-2">Tiempo de paro no programado</div>
                      <div class="">
                        {{ partesDesdeSegundos(kpisActuales.segParoNP).h }} :
                        {{ partesDesdeSegundos(kpisActuales.segParoNP).m }} :
                        {{ partesDesdeSegundos(kpisActuales.segParoNP).s }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="false">
                <v-card class="pa-4" elevation="1" style="border-radius:12px;">
                  <div class="d-flex align-center mb-2">
                    <div class="mr-3"
                      style="width:36px;height:36px;border-radius:50%;background:#C82A54;color:white;display:flex;align-items:center;justify-content:center;">
                      <v-icon small color="white">mdi-timer-outline</v-icon>
                    </div>
                    <div>
                      <div class="text-subtitle-2">Tiempo Muerto</div>
                      <div class="">
                        {{ partesDesdeSegundos(kpisActuales.tiempoMuertoSeg).h }} :
                        {{ partesDesdeSegundos(kpisActuales.tiempoMuertoSeg).m }} :
                        {{ partesDesdeSegundos(kpisActuales.tiempoMuertoSeg).s }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="false">
                <v-card class="pa-4" elevation="1" style="border-radius:12px;">
                  <div class="d-flex align-center mb-2">
                    <div class="mr-3"
                      style="width:36px;height:36px;border-radius:50%;background:#C82A54;color:white;display:flex;align-items:center;justify-content:center;">
                      <v-icon small color="white">mdi-calendar-clock</v-icon>
                    </div>
                    <div>
                      <div class="text-subtitle-2">
                        Área de mejora del turno expresada en tiempo
                      </div>
                      <div class="">
                        {{ partesDesdeSegundos(response.resumen.segundosTiempoInactividad).h }}
                        :
                        {{ partesDesdeSegundos(response.resumen.segundosTiempoInactividad).m }}
                        :
                        {{ partesDesdeSegundos(response.resumen.segundosTiempoInactividad).s }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <!-- === NUEVO: Tabla de operacionesODT al final === -->
      <v-col v-if="showSideKpis && _operacionesODT.length" cols="12">
        <v-data-table :headers="headersOperacionesODT" :items="_operacionesODT" dense disable-pagination
          hide-default-footer>
          <!-- Renderiza la celda de la columna 'tiempoMinXUnidad' -->
          <template v-slot:item.tiempoMinXUnidad="{ item }">
            {{ item.tiempoMinXUnidad }} Segundos
          </template>
          <template v-slot:item.tcReal="{ item }">
            {{ Math.round(item.tcReal) }} Segundos
          </template>
        </v-data-table>

      </v-col>
      <!-- === FIN NUEVO === -->

    </v-col>

    <v-dialog v-model="lineaParosTurno" persistent width="80%">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <LineaParosTurno :horas="_rowsHora" :ver-activo="conflineaParos.verActivo" :ver-programado="conflineaParos.verProg" :ver-no-programado="conflineaParos.verNoProg"/>
        </v-card-text>
        <v-card-actions>
          <v-btn class="ml-auto" @click="lineaParosTurno = !lineaParosTurno" color="primary">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="piezasNoOkTurno" persistent width="80%">
      <v-card>
        <v-card-title>Piezas No OK del turno</v-card-title>
        <v-card-text>
          <!-- usamos las mismas horas que LineaParosTurno -->
          <PiezasNoOkTurno :horas="_rowsHora" />
        </v-card-text>
        <v-card-actions>
          <v-btn class="ml-auto" color="primary" @click="piezasNoOkTurno = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex/dist/vuex.common.js';
import LineaParosTurno from './LineaParosTurno.vue';
import PiezasNoOkTurno from './PiezasNoOkTurno.vue';
import HistoricoTCGrafica from './HistoricoTCGrafica.vue';

export default {
  components: {
    LineaParosTurno,
    PiezasNoOkTurno,
    HistoricoTCGrafica
  },
  props: {
    showSideKpis: { type: Boolean, default: true },
    value: { type: Object, required: true }, // { resumen, horas | Horas }
    categoriasHoras: { type: Array, default: null },           // ['07:00 - 08:00', ...]
    _cavidadesElegidas: { type: Array, default: () => [] },    // [idTokenExtra...]
    _articulosElegidos: { type: Array, default: () => [] },    // [idArticulo...]
    _nombresPorCavidad: { type: Object, default: () => ({}) }, // {2:'Pieza Ok'}
    _nombresPorArticulo: { type: Object, default: () => ({}) },// {1:'PRODUCTO PRUEBA 001'}
    agruparPor: { type: String, default: 'articulos' }, // 'cavidades' | 'articulos'
    gfRows: { type: Array, default: () => [] },
    modo: { type: String, default: 'horas' }, // 'horas' | 'dias'
    fuente: { type: Object, default: null },    // { dias:[...], resumen:{...} }
    mostrarTotal: { type: Boolean, default: true },
    mostrarSiempreNombreArt: { type: Boolean, default: true }, // Muestra el nombre del artículo o lo agrupa
    esperadasInicianOcultas: { type: Boolean, default: true },
  // 👇 NUEVOS PROPS para el diálogo histórico
    idMaquinaIns: { type: Number, default: null },         // ID de máquina
    fecha: { type: String, default: null },                 // Fecha seleccionada
    turnoSeleccionado: { type: Object, default: () => ({}) }, // Objeto turno completo
    maquinaSeleccionadaNombre: { type: String, default: '' }, // Nombre de la máquina
  },
  data() {
    return {
      paletteBars: ['#1E88E5', '#FB8C00', '#26A69A', '#8E24AA', '#EF5350', '#5E35B1'],
      secondPalette: ['#3949AB', '#F4511E', '#00796B', '#7CB342', '#D81B60', '#00ACC1'],
      coloresClaros: ["#E3F2FD", "#FFF3E0"],
      paletteLines: ['#FF4D4F', '#13C2C2', '#FA8C16', '#2FC25B', '#1890FF', '#EB2F96'],
      error: '#EF5350',
      errorBg: '#FDECEC',
      success: '#26A69A',
      successBg: '#E8F5E9',
      _esperadasYaOcultas: false,
      intervalTcReal: null,
      lineaParosTurno: false,
      piezasNoOkTurno: false,
      dialogHistoricoTC: false,
      conflineaParos: {
        verActivo: true,
        verProg: true,
        verNoProg: true,

      }
    }
  },
  computed: {
        tieneDatosGrafica() {
      if (this.modo === 'dias') {
        const f = this.fuente;
        const hayDias = f && Array.isArray(f.dias) && f.dias.length > 0;
        // si prefieres ser más estricto, puedes validar también categorías o series:
        // const haySeries = (this._seriesDias || []).some(s => (s.data || []).some(v => v != null));
        return !!hayDias;
      }
      // horas
      return this.response && Object.keys(this.response).length > 0;
    },

  tieneActividad() {
      if (this.modo === 'dias') {
        const r =
          this.fuente?.resumen ||
          this.response?.resumen ||
          this.response?.Resumen ||
          {};
        if (typeof r.conActividad === 'boolean') return r.conActividad;
      } else {
        const rr =
          this.response?.resumen ||
          this.response?.Resumen ||
          this.response ||
          {};
        if (typeof rr.conActividad === 'boolean') return rr.conActividad;
      }
      // Si el backend no manda la bandera, mantenemos el comportamiento actual
      return true;
    },
  tcProgramadoSegPza() {
    const items = Array.isArray(this._operacionesODT) ? this._operacionesODT : [];
    if (!items.length) return 0;

    // Extrae el TC de cada renglón usando alias comunes
    const getTc = it => {
      const cand = [
        it.tiempoMinXUnidad,
        it.tiempo_ciclo,
        it.tiempoCiclo,
        it.cycle_time,
        it.tc
      ];
      for (const v of cand) {
        const n = Number(v);
        if (Number.isFinite(n) && n > 0) return n;
      }
      return null;
    };

    const vals = items.map(getTc).filter(v => v != null);
    if (!vals.length) return 0;

    // Pondera por piezas reportadas si existe (cantidad, piezas, etc.)
    const pesos = items.map(it => Number(it.piezasReportadas ?? it.cantidad ?? it.total ?? 0) || 0);
    const tienePesos = pesos.some(w => w > 0);

    if (tienePesos) {
      let sumVW = 0, sumW = 0;
      for (let i = 0; i < vals.length; i++) {
        sumVW += vals[i] * (pesos[i] || 0);
        sumW  += (pesos[i] || 0);
      }
      if (sumW > 0) return sumVW / sumW;
    }
    // Promedio simple si no hay pesos
    return vals.reduce((a, b) => a + b, 0) / vals.length;
  },

   tcProgramadoTxt() {
    const s = Number(this.tcProgramadoSegPza); // seg/pza
    if (!Number.isFinite(s) || s <= 0) return '—';
    return `${s.toFixed(1)} seg/pza`;
  },

  // Diferencia vs real ponderado (positiva = real más lento)
  tcDeltaSeg() {
    return Number(this.tcRealPromedioPonderadoSegHora) - Number(this.tcProgramadoSegPza);
  },
  tcDeltaTxt() {
    const d = this.tcDeltaSeg;
    if (!Number.isFinite(d)) return '';
    const sign = d > 0 ? '+' : '';
    return `Δ ${sign}${d.toFixed(0)} s`;
  },
    resumenPiezasPeriodo() {
      const rows = Array.isArray(this.gfRows) ? this.gfRows : []
      const esperadas = rows.reduce((s, r) => s + Number(r.teoricas || 0), 0)
      const ok = rows.reduce((s, r) => s + Number(r.ok || 0), 0)
      // si el EP no manda noOk, infiérelo de esperadas - ok, pero si viene úsalo
      // ✅ sin forzar
      const noOkSum = rows.reduce((s, r) => s + Number(r.noOk || 0), 0)
      const noOk = noOkSum // si no viene, queda 0 y no “inventamos” nada
      const delta = ok - esperadas
      return { esperadas, ok, noOk, delta }
    },
    kpisActuales() {
      // helper: toma el primer alias disponible y lo convierte a número
      const pick = (o, ...keys) => {
        for (const k of keys) {
          const v = o && o[k];
          if (v !== undefined && v !== null) return Number(v) || 0;
        }
        return 0;
      };
      // helper: suma una lista de aliases sobre un arreglo de objetos
      const sumFrom = (arr, ...keys) =>
        (Array.isArray(arr) ? arr : []).reduce((s, it) => s + pick(it, ...keys), 0);

      // ===== MODO "DÍAS" =====
      if (this.modo === 'dias') {
        const r = this.fuente?.resumen || {};
        const fb = this.resumenPiezasPeriodo;

        const esperadas = +(r.esperadas ?? r.teo ?? fb.esperadas ?? 0);
        const ok = +(r.ok ?? fb.ok ?? 0);
        const noOk = +(r.noOk ?? fb.noOk ?? 0);
        const delta = +(r.delta ?? (ok - esperadas));

        // alias para paros
        let segParoProg = pick(
          r,
          'segParoProg',
          'segundosParoProgramado',
          'SegundosParoProgramado',
          'segundosTiempoParoProgramado'
        );
        let segParoNP = pick(
          r,
          'segParoNP',
          'segundosParoNoProgramado',
          'SegundosParoNoProgramado',
          'SegundosParo',
          'segundosTiempoParo'
        );

        // fallback: sumar desde fuente.dias si no llegó en resumen
        if ((!segParoProg || !segParoNP) && Array.isArray(this.fuente?.dias)) {
          const dias = this.fuente.dias;
          if (!segParoProg) {
            segParoProg = sumFrom(
              dias,
              'segParoProg',
              'segundosParoProgramado',
              'SegundosParoProgramado',
              'segundosTiempoParoProgramado'
            );
          }
          if (!segParoNP) {
            segParoNP = sumFrom(
              dias,
              'segParoNP',
              'segundosParoNoProgramado',
              'SegundosParoNoProgramado',
              'SegundosParo',
              'segundosTiempoParo'
            );
          }
        }

        return {
          oee: +(r.oee ?? 0),
          disp: +(r.disp ?? 0),
          rend: +(r.rend ?? 0),
          cali: +(r.cali ?? 0),
          esperadas, ok, noOk, delta,
          segParoProg, segParoNP,
        };
      }

      // ===== MODO "HORAS" =====
      const rr = this.response?.resumen || this.response?.Resumen || {};

      // alias para paros (lo importante: soporta 'segundosTiempoParo' del backend)
      let segParoProg = pick(
        rr,
        'segundosTiempoParoProgramado',
        'SegundosParoProgramado',
        'segundosParoProgramado',
        'segParoProg'
      );
      let segParoNP = pick(
        rr,
        'segundosTiempoParo',
        'SegundosParo',
        'segundosParo',
        'SegundosParoNoProgramado',
        'segundosParoNoProgramado',
        'segParoNP'
      );

      // fallback: sumar desde response.horas si faltan
      if ((!segParoProg || !segParoNP) && Array.isArray(this.response?.horas)) {
        const horas = this.response.horas;
        if (!segParoProg) {
          segParoProg = sumFrom(horas, 'segundosParoProgramado', 'SegundosParoProgramado');
        }
        if (!segParoNP) {
          segParoNP = sumFrom(horas, 'segundosParo', 'SegundosParo', 'segundosParoNoProgramado', 'SegundosParoNoProgramado');
        }
      }

      return {
        oee: +(rr.OEE || rr.oee || 0),
        disp: +(rr.Disponibilidad || rr.disponibilidad || 0),
        rend: +(rr.Rendimiento || rr.rendimiento || 0),
        cali: +(rr.Calidad || rr.calidad || 0),
        ok: +(rr.PiezasOkTotales || rr.ok || 0),
        esperadas: +(rr.PiezasTeoricasTotales || rr.teo || 0),
        noOk: +(rr.PiezasNoOkTotales || rr.noOk || 0),
        delta: +((rr.PiezasOkTotales ?? rr.ok ?? 0) - (rr.PiezasTeoricasTotales ?? rr.teo ?? 0)),
        segParoProg,
        segParoNP,
        tiempoMuertoSeg: rr.tiempoMuertoSeg ?? 0
      };
    },
    _seriesDias() {
      if (this.modo !== 'dias') return [];

      const dias = this._rowsPeriodo;
      const cats = this._categoriasX;

      const entidades = Array.from(
        new Set(dias.flatMap(d => (d.grupos || []).map(g => g.label || g.nombre || g.id)))
      );

      const seriesBarras = entidades.map((lbl, idx) => ({
        name: lbl,
        type: 'column',
        data: cats.map(f => {
          const d = dias.find(x => x.fecha === f);
          const g = (d?.grupos || []).find(x => (x.label || x.nombre || x.id) === lbl);
          if (!g) return 0;
          const A = Number(g.A ?? g.disponibilidad ?? 0);
          const P = Number(g.P ?? g.rendimiento ?? 0);
          const Q = Number(g.Q ?? g.calidad ?? 0);
          const oee = (g.oee != null) ? Number(g.oee) : (A * P * Q) / 10000;
          return oee;
        }),
        color: this.paletteBars[idx % this.paletteBars.length],
      }));

      // línea total (opcional)
      const serieLinea = {
        name: 'OEE total',
        type: 'line',
        data: cats.map(f => {
          const d = dias.find(x => x.fecha === f) || {};
          const gs = d.grupos || [];
          const teo = gs.reduce((s, g) => s + Number(g.teoricas || 0), 0);
          if (!teo) return 0;
          const w = k => gs.reduce((s, g) => s + Number((g[k] ?? g[k?.toUpperCase?.()] ?? 0)) * Number(g.teoricas || 0), 0) / teo;
          const A = w('disponibilidad'), P = w('rendimiento'), Q = w('calidad');
          return (A * P * Q) / 10000;
        })
      };

      // 👇 si no quieres verla, no la agregues
      return this.mostrarTotal
        ? [...seriesBarras, serieLinea]
        : seriesBarras;
    },
    _rowsPeriodo() {
      const src = this.fuente || this.value || {};
      if (this.modo === 'dias') return Array.isArray(src.dias) ? src.dias : [];
      // fallback actual (horas)
      const data = src?.horas ?? src ?? [];
      return Array.isArray(data) ? data : [];
    },

    _categoriasX() {
      if (this.modo === 'dias') {
        return this._rowsPeriodo.map(d => d.fecha).filter(Boolean);
      }
      // ⇩ lo que ya tenías para horas
      const rows = this._rowsHora;
      const seen = new Set(); const cats = [];
      rows.forEach(r => {
        const desde = r.desdeHora ?? r.horaInicio;
        const hasta = r.hastaHora ?? r.horaFin;
        if (desde && hasta) {
          const label = `${desde} - ${hasta}`;
          if (!seen.has(label)) { seen.add(label); cats.push(label); }
        }
      });
      return cats;
    },

    ...mapState({
      nombreEmpresa: 'nombreEmpresa',
    }),
    response() {
      return Object.keys(this.value).length > 0 ? this.value : {}
    },
    _rowsHora() {
      const data = this.response?.horas ?? this.response ?? [];
      return Array.isArray(data) ? data : [];
    },

    // ----- Categorías X dinámicas -----
    _horasCategorias() {
      if (Array.isArray(this.categoriasHoras) && this.categoriasHoras.length) {
        return this.categoriasHoras;
      }
      const rows = this._rowsHora;
      const seen = new Set();
      const cats = [];
      rows.forEach(r => {
        const desde = r.desdeHora ?? r.horaInicio;
        const hasta = r.hastaHora ?? r.horaFin;
        if (desde && hasta) {
          const label = `${desde} - ${hasta}`;
          if (!seen.has(label)) { seen.add(label); cats.push(label); }
        }
      });
      return cats;
    },

    // ----- Cavidades activas -----
    _cavidadesActivas() {
      const rows = this._rowsHora;
      const setPorArticulo = new Set();

      if (this._articulosElegidos?.length) {
        rows.forEach(h =>
          (h.cavidades || []).forEach(c => {
            const tiene = (c.articulos || []).some(a =>
              this._articulosElegidos.includes(a.idArticulo)
            );
            if (tiene) setPorArticulo.add(c.idTokenExtra);
          })
        );
      }

      let base = (this._cavidadesElegidas?.length
        ? this._cavidadesElegidas
        : Array.from(setPorArticulo));

      if (!base?.length) {
        rows.forEach(h => (h.cavidades || []).forEach(c => setPorArticulo.add(c.idTokenExtra)));
        base = Array.from(setPorArticulo);
      }
      return base;
    },

    // ----- Artículos para líneas -----
    _articulosSerie() {
      if (this._articulosElegidos?.length) return this._articulosElegidos;
      const ids = new Set();
      this._rowsHora.forEach(r =>
        (r.cavidades || []).forEach(c =>
          (c.articulos || []).forEach(a => ids.add(a.idArticulo))
        )
      );
      return Array.from(ids);
    },

    // ----- Opciones ApexCharts -----
    horaHoraOpts() {
      const usandoDias = (this.modo === 'dias');
      const pct2 = v => `${(Number(v) ?? 0).toFixed(2)}%`;
      const categories = usandoDias ? this._categoriasX : this._horasCategorias;

      const agruparArt = ((this.agruparPor || '').toLowerCase() === 'articulos');
      const nCols = usandoDias
        ? this._seriesDias.filter(s => s.type === 'column').length
        : (agruparArt ? this._articulosSerie.length : this._cavidadesActivas.length);

      // en modo días solo hay 1 línea (OEE total)
      const nLineasArt = agruparArt ? this._articulosSerie.length : this._cavidadesActivas.length;
      const nLineasTot = 0; // ← ver punto 3
      const nLineasRate = agruparArt ? this._articulosSerie.length : this._cavidadesActivas.length;
      const nLines = usandoDias ? 1 : (nLineasArt + nLineasTot + nLineasRate);

      const self = this;

      // const self = this;

      return {
        chart: {
          type: 'line',
          height: 500,
          toolbar: { show: true },
          events: {
            mounted(chart) {
              if (!self.esperadasInicianOcultas || self._esperadasYaOcultas) return;
              (chart.w?.globals?.seriesNames || []).forEach(name => {
                if (typeof name === 'string' && name.toLowerCase().startsWith('esperadas')) {
                  chart.hideSeries(name);
                }
              });
              self._esperadasYaOcultas = true;
            },
            mounted() {
              this.initialize();
              this.getAreas();
              
              this.iniciarPollingTcReal();
            },

            beforeDestroy() {
              this.stopOeeLongPoll();
              this.detenerPollingTcReal();
              if (this.intervalId) clearInterval(this.intervalId);
            },
            updated(chart) {
              if (!self.esperadasInicianOcultas || self._esperadasYaOcultas) return;
              (chart.w?.globals?.seriesNames || []).forEach(name => {
                if (typeof name === 'string' && name.toLowerCase().startsWith('esperadas')) {
                  chart.hideSeries(name);
                }
              });
              self._esperadasYaOcultas = true;
            }
          }
        },
        xaxis: {
          categories,
          tickPlacement: 'between',
          labels: { rotate: -35, rotateAlways: true, trim: false, minHeight: 58, maxHeight: 58, style: { fontSize: '11px' }, offsetY: 6 }
        },
        legend: { show: true, position: 'top' },
        plotOptions: { bar: { columnWidth: '40%', borderRadius: 4 }, dataLabels: { position: 'center' } },
        stroke: {
          width: Array(nCols).fill(0).concat(Array(nLines).fill(3)),
          curve: 'smooth',
          dashArray: [
            ...Array(nCols).fill(0),
            ...Array(usandoDias ? 1 : nLineasArt).fill(0),
            ...Array(usandoDias ? 0 : nLineasTot).fill(5),
            ...Array(usandoDias ? 0 : nLineasRate).fill(0)
          ]
        },
        markers: { size: Array(nCols).fill(0).concat(Array(nLines).fill(4)), strokeWidth: 2, strokeColors: '#fff' },
        dataLabels: usandoDias
          ? { enabled: true, enabledOnSeries: [...Array.from({ length: nCols }, (_, i) => i)], formatter: v => pct2(v), offsetY: -8, style: { fontSize: '11px' } }
          : { enabled: true, enabledOnSeries: [...Array.from({ length: nCols }, (_, i) => i), ...Array.from({ length: nLines }, (_, i) => nCols + i)], offsetY: 0, formatter: v => Number(v ?? 0) },
        tooltip: usandoDias
          ? { shared: true, intersect: false, y: { formatter: v => pct2(v) } } // ⬅️ 0 decimales
          : { shared: true, intersect: false },
        grid: { padding: { left: 8, right: 8 } },
        yaxis: usandoDias
          ? [{ max: 100, min: 0, tickAmount: 5, labels: { formatter: v => pct2(v) }, title: { text: 'OEE (%)' } }]
          : { min: 0, forceNiceScale: true }
      };
    },
    

    horaHoraSeries() {
      if (this.modo === 'dias') return this._seriesDias;
      const horas = this._horasCategorias || [];
      const rows = this._rowsHora;
      const cavidades = this._cavidadesActivas;

      // Construcción de barras con tipo de agrupación
      const agruparArt = (this.agruparPor || '').toLowerCase() === 'articulos';

      let seriesBars;

      if (agruparArt) {
        // Barras agrupadas por ARTÍCULO (suma de cavidades que producen ese artículo)
        const articulos = this._articulosSerie; // ya existe en tu componente
        seriesBars = articulos.map((idArt, idx) => {
          const data = (this._horasCategorias || []).map(label => {
            const { desde, hasta } = this._parHora(label);
            const rec = rows.find(r =>
              (r.desdeHora ?? r.horaInicio) === desde &&
              (r.hastaHora ?? r.horaFin) === hasta
            );
            if (!rec) return 0;

            // Suma piezas OK de todas las cavidades que tienen este artículo en esa hora
            const sumaOk = (rec.cavidades || []).reduce((acc, cav) => {
              const tiene = (cav.articulos || []).some(a => a.idArticulo === idArt);
              if (!tiene) return acc;
              const ok = Number(cav.piezasOkHora ?? cav.reales ?? cav.ok ?? 0);
              return acc + (isNaN(ok) ? 0 : ok);
            }, 0);

            return sumaOk;
          });

          return {
            name: this._nombreArticulo(idArt) || `Artículo ${idArt}`,
            type: 'column',
            data,
            color: this.paletteBars[idx % this.paletteBars.length]
          };
        });
      } else {
        // Barras por CAVIDAD (comportamiento actual)
        const cavidades = this._cavidadesActivas;
        seriesBars = cavidades.map((idCav, idx) => {
          const data = (this._horasCategorias || []).map(label => {
            const { desde, hasta } = this._parHora(label);
            const rec = rows.find(r =>
              (r.desdeHora ?? r.horaInicio) === desde &&
              (r.hastaHora ?? r.horaFin) === hasta
            );
            if (!rec) return 0;

            const cav = (rec.cavidades || []).find(c => c.idTokenExtra === idCav);
            if (!cav) return 0;

            if (this._articulosElegidos?.length) {
              const tiene = (cav.articulos || []).some(a =>
                this._articulosElegidos.includes(a.idArticulo)
              );
              if (!tiene) return 0;
            }

            return Number(cav.piezasOkHora ?? cav.reales ?? cav.ok ?? 0);
          });

          return {
            name: this._nombreCavidad(idCav),
            type: 'column',
            data,
            color: this.paletteBars[idx % this.paletteBars.length]
          };
        });
      }

      // Líneas (ESPERADAS) — ahora usando piezasEsperadasTeoricasHora
      const seriesEsperadas = agruparArt
        ? this._makeEsperadasSeriesPorArticulo(horas, rows, cavidades)
        : this._makeEsperadasSeriesPorCavidad(horas, rows, cavidades);

      // === NUEVO: Líneas RATE (piezasRateHora) ===
      const seriesRate = agruparArt
        ? this._makeRateSeriesPorArticulo(horas, rows, cavidades)
        : this._makeRateSeriesPorCavidad(horas, rows, cavidades);

      return [
        ...seriesBars,
        ...seriesEsperadas,
        ...seriesRate
      ];

      // Líneas por cavidad (ESPERADAS) — EXACTO del JSON, sin sumar ni filtrar por artículo
      // const seriesEsperadas = this._makeEsperadasSeriesPorCavidad(horas, rows, cavidades);

      // SIN “Esperadas por artículo” y SIN “Esperadas (Total)”
    },

    // ----- KPIs para tarjetas -----
    kpiOEEValue() {
      const v = Number(this.response?.resumen?.oee ?? 0);
      return Math.max(0, Math.min(100, v));
    },
    kpiParoPct() {
      const np = Number(this.response?.resumen?.segundosTiempoParo ?? 0);
      const pp = Number(this.response?.resumen?.segundosTiempoParoProgramado ?? 0);
      const tot = np + pp;
      return tot > 0 ? Math.round((np / tot) * 100) : 0;
    },
    kpiParoProgPct() {
      const np = Number(this.response?.resumen?.segundosTiempoParo ?? 0);
      const pp = Number(this.response?.resumen?.segundosTiempoParoProgramado ?? 0);
      const tot = np + pp;
      return tot > 0 ? Math.round((pp / tot) * 100) : 0;
    },
    kpiNoOkPct() {
      const ok = Number(this.response?.resumen?.piezasOkTotales ?? 0);
      const no = Number(this.response?.resumen?.piezasNoOkTotales ?? 0);
      const tot = ok + no;
      return tot > 0 ? Math.round((no / tot) * 100) : 0;
    },

    ladosEsperadas() {
      const data = this.response || {};
      const agruparArt = (this.agruparPor || '').toLowerCase() === 'articulos';

      // --- V2: usar resumen por cavidad si está disponible y NO agrupamos por artículos ---
      const cavRes = data?.resumen?.resumenCavidades?.cavidades || [];
      if (!agruparArt && Array.isArray(cavRes) && cavRes.length) {
        // Recopilar nombres de artículos por cavidad desde HORAS (para la etiqueta)
        const horas = Array.isArray(data.horas) ? data.horas : [];
        const nombresPorCav = new Map(); // cavId -> Set(nombres)
        for (const h of horas) {
          for (const c of (h?.cavidades || [])) {
            const key = c?.idTokenExtra ?? 0;
            const set = nombresPorCav.get(key) || new Set();
            // for (const a of (c?.articulos || [])) {
            //   const n = (a?.nombre ?? (this._nombreArticulo ? this._nombreArticulo(a?.idArticulo) : null))?.trim();
            //   if (n) set.add(n);
            // }
            for (const a of (c?.articulos || [])) {
              const lab = this._formatArtLabel(a)?.trim();
              if (lab) set.add(lab);
            }
            nombresPorCav.set(key, set);
          }
        }

        return cavRes.map(c => {
          const key = c?.idTokenExtra ?? 0;
          const nombres = Array.from(nombresPorCav.get(key) || []);
          const etiquetaArts =
            nombres.length === 0 ? 'Sin artículo'
              : nombres.length === 1 ? nombres[0]
                : `[${nombres.join(', ')}]`;
          const separador = (nombres.length <= 1) ? ' — ' : ' - ';
          const teo = Number(c?.piezasEsperadas) || 0;

          return {
            valor: teo,
            cavidad: `${c?.cavidad || 'Cavidad'}${separador}${etiquetaArts}`, // aquí sí mostramos artículos
            articulos: nombres,
            token: c?.cavidad || 'Cavidad',
          };
        });
      }

      // --- Fallback: lógica original por HORAS ---
      const horas = Array.isArray(data.horas) ? data.horas : [];
      if (!horas.length) return [];

      // Agrupar por ARTÍCULOS
      if (agruparArt) {
        // Último artículo conocido por cavidad (hacia atrás)
        const ultArtPorCav = new Map(); // idCav -> [{idArticulo, nombre}]
        for (let i = horas.length - 1; i >= 0; i--) {
          const cavs = Array.isArray(horas[i]?.cavidades) ? horas[i].cavidades : [];
          for (const c of cavs) {
            const idCav = c?.idTokenExtra;
            if (idCav == null || ultArtPorCav.has(idCav)) continue;
            const arts = Array.isArray(c?.articulos) ? c.articulos : [];
            if (arts.length) {
              const pack = arts
                .map(a => ({
                  idArticulo: a?.idArticulo ?? a?.id,
                  nombre: a?.nombre ?? (this._nombreArticulo ? this._nombreArticulo(a?.idArticulo ?? a?.id) : null)
                }))
                .filter(x => x.idArticulo != null);
              if (pack.length) ultArtPorCav.set(idCav, pack);
            }
          }
        }

        const last = horas[horas.length - 1];
        const cavsLast = Array.isArray(last?.cavidades) ? last.cavidades : [];
        const porArticulo = new Map();

        for (const cav of cavsLast) {
          const teoAcum = Number(
            cav?.piezasTeoricasMinuto ??
            cav?.piezasTeoricasTotales ??
            cav?.piezasTeoricasHora ??
            cav?.piezasTeoricas ?? 0
          );

          // Artículos de la última hora; si no hay, usa fallback
          let arts = Array.isArray(cav?.articulos) ? cav.articulos : [];
          if (!arts.length) {
            const pack = ultArtPorCav.get(cav?.idTokenExtra) || [];
            arts = pack.map(p => ({ idArticulo: p.idArticulo, nombre: p.nombre }));
          }

          // for (const a of arts) {
          //   const id = a?.idArticulo ?? a?.id;
          //   if (id == null) continue;
          //   const etiqueta = this._formatArtLabel(a) || this._formatArtLabel(id);
          //   const prev = porArticulo.get(id)?.valor ?? 0;
          //   porArticulo.set(id, { valor: prev + (isNaN(teoAcum) ? 0 : teoAcum), cavidad: etiqueta });
          // }
          for (const a of arts) {
            const id = a?.idArticulo ?? a?.id;
            if (id == null) continue;

            const etiqueta = this._formatArtLabel(a);
            const prev = porArticulo.get(id)?.valor ?? 0;
            const cavLbl = porArticulo.get(id)?.cavidad || etiqueta;

            porArticulo.set(id, {
              valor: prev + (isNaN(teoAcum) ? 0 : teoAcum),
              cavidad: cavLbl
            });
          }
        }
        return Array.from(porArticulo.values());
      }

      // Agrupar por CAVIDAD (etiqueta con artículos desde HORAS)
      const nombresPorCav = new Map(); // cavId -> Set(nombre)
      for (const h of horas) {
        const cavs = h?.cavidades || [];
        for (const c of cavs) {
          const set = nombresPorCav.get(c.idTokenExtra) || new Set();
          // for (const a of (c.articulos || [])) {
          //   const nombre = (a?.nombre ?? (this._nombreArticulo ? this._nombreArticulo(a?.idArticulo) : null));
          //   const n = typeof nombre === 'string' ? nombre.trim() : null;
          //   if (n) set.add(n);
          // }
          for (const a of (c.articulos || [])) {
            const lab = this._formatArtLabel(a);
            if (lab) set.add(lab);
          }
          nombresPorCav.set(c.idTokenExtra, set);
        }
      }

      const last = horas[horas.length - 1];
      const cavsLast = Array.isArray(last?.cavidades) ? last.cavidades : [];

      return cavsLast.map(cav => {
        const nombres = Array.from(nombresPorCav.get(cav.idTokenExtra) || []);
        const etiquetaArts =
          nombres.length === 0 ? 'Sin artículo'
            : nombres.length === 1 ? nombres[0]
              : `[${nombres.join(', ')}]`;

        const teoAcum = Number(
          cav?.piezasTeoricasMinuto ??
          cav?.piezasTeoricasTotales ??
          cav?.piezasTeoricasHora ??
          cav?.piezasTeoricas ?? 0
        );

        const separador = (nombres.length <= 1) ? ' — ' : ' - ';

        return {
          valor: isNaN(teoAcum) ? 0 : teoAcum,
          cavidad: `${cav?.cavidad ?? 'Cavidad'}${separador}${etiquetaArts}`,
          articulos: nombres,
          token: cav?.cavidad ?? 'Cavidad',
        };
      });
    },
    lados() {
      const data = this.response || {};
      const agruparArt = (this.agruparPor || '').toLowerCase() === 'articulos';

      // --- V2: usar resumen por cavidad (OK neto desde backend) ---
      const cavRes = data?.resumen?.resumenCavidades?.cavidades || [];
      if (!agruparArt && Array.isArray(cavRes) && cavRes.length) {
        // Tooltip con artículos (usando "[CÓDIGO] Nombre")
        const horas = Array.isArray(data.horas) ? data.horas : [];
        const nombresPorCav = new Map();
        for (const h of horas) {
          for (const c of (h?.cavidades || [])) {
            const key = c?.idTokenExtra ?? 0;
            const set = nombresPorCav.get(key) || new Set();
            for (const a of (c?.articulos || [])) {
              const lab = this._formatArtLabel(a)?.trim();
              if (lab) set.add(lab);
            }
            nombresPorCav.set(key, set);
          }
        }

        return cavRes.map(c => {
          const key = c?.idTokenExtra ?? 0;
          const nombres = Array.from(nombresPorCav.get(key) || []);
          const okNet = Number(c?.piezasOk) || 0; // OK neto

          return {
            valor: okNet,
            cavidad: c?.cavidad || 'Cavidad',
            articulos: nombres,
            token: c?.cavidad || 'Cavidad',
          };
        });
      }

      // --- Fallback por HORAS ---
      const horas = Array.isArray(data.horas) ? data.horas : [];
      if (!horas.length) return [];

      // Agrupar por ARTÍCULOS (OK neto por artículo)
      if (agruparArt) {
        // Último artículo no vacío por cavidad (hacia atrás)
        const ultArtPorCav = new Map();
        for (let i = horas.length - 1; i >= 0; i--) {
          const cavs = Array.isArray(horas[i]?.cavidades) ? horas[i].cavidades : [];
          for (const c of cavs) {
            const idCav = c?.idTokenExtra;
            if (idCav == null || ultArtPorCav.has(idCav)) continue;
            const arts = Array.isArray(c?.articulos) ? c.articulos : [];
            if (arts.length) {
              const pack = arts
                .map(a => ({
                  idArticulo: a?.idArticulo ?? a?.id,
                  nombre: this._formatArtLabel(a)
                }))
                .filter(x => x.idArticulo != null);
              if (pack.length) ultArtPorCav.set(idCav, pack);
            }
          }
        }

        const last = horas[horas.length - 1];
        const cavsLast = Array.isArray(last?.cavidades) ? last.cavidades : [];
        const porArticulo = new Map();

        for (const cav of cavsLast) {
          const okAcum = Number(cav?.piezasOkAcumulado ?? cav?.piezasOkHora ?? cav?.ok ?? 0);
          const noOkAcum = Number(cav?.piezasNoOkAcumulado ?? cav?.piezasNoOkHora ?? cav?.noOk ?? cav?.scrap ?? 0);
          const okNeto = Math.max(0, okAcum - noOkAcum);

          // Artículos de la última hora; si no hay, usa fallback
          let arts = Array.isArray(cav?.articulos) ? cav.articulos : [];
          if (!arts.length) {
            const pack = ultArtPorCav.get(cav?.idTokenExtra) || [];
            arts = pack.map(p => ({ idArticulo: p.idArticulo, nombre: p.nombre }));
          }

          for (const a of arts) {
            const id = a?.idArticulo ?? a?.id;
            if (id == null) continue;

            const etiqueta = this._formatArtLabel(a);
            const prev = porArticulo.get(id)?.valor ?? 0;
            const cavLbl = porArticulo.get(id)?.cavidad || etiqueta;

            porArticulo.set(id, {
              valor: prev + okNeto,
              cavidad: cavLbl
            });
          }
        }
        return Array.from(porArticulo.values());
      }

      // Agrupar por CAVIDAD (OK neto por cavidad; tooltip con "[CÓDIGO] Nombre")
      const nombresPorCav = new Map();
      for (const h of horas) {
        const cavs = h?.cavidades || [];
        for (const c of cavs) {
          const set = nombresPorCav.get(c.idTokenExtra) || new Set();
          for (const a of (c.articulos || [])) {
            const lab = this._formatArtLabel(a);
            if (lab) set.add(lab);
          }
          nombresPorCav.set(c.idTokenExtra, set);
        }
      }

      const last = horas[horas.length - 1];
      const cavsLast = Array.isArray(last?.cavidades) ? last.cavidades : [];

      return cavsLast.map(cav => {
        const nombres = Array.from(nombresPorCav.get(cav.idTokenExtra) || []);
        const okAcum = Number(cav?.piezasOkAcumulado ?? cav?.piezasOkHora ?? cav?.ok ?? 0);
        const noOkAcum = Number(cav?.piezasNoOkAcumulado ?? cav?.piezasNoOkHora ?? cav?.noOk ?? cav?.scrap ?? 0);
        const okNeto = Math.max(0, okAcum - noOkAcum);

        return {
          valor: isNaN(okNeto) ? 0 : okNeto,
          cavidad: `${cav?.cavidad ?? 'Cavidad'}`,
          articulos: nombres,
          token: cav?.cavidad ?? 'Cavidad',
        };
      });
    },
    ladosDelta() {
      // Usar exactamente los mismos datos que las tarjetas de:
      // Esperadas (ladosEsperadas), OK (lados) y NO OK (ladosNoOk)
      const esperadas = Array.isArray(this.ladosEsperadas) ? this.ladosEsperadas : [];
      const okArr     = Array.isArray(this.lados)          ? this.lados          : [];
      const noOkArr   = Array.isArray(this.ladosNoOk)      ? this.ladosNoOk      : [];

      if (!esperadas.length) return [];

      const n   = Math.max(esperadas.length, okArr.length, noOkArr.length);
      const num = v => Number(v ?? 0) || 0;

      const getBase = idx => esperadas[idx] || okArr[idx] || noOkArr[idx] || {};

      const res = [];
      for (let i = 0; i < n; i++) {
        const base  = getBase(i);
        const teo   = num(base.valor);              // Esperadas
        const ok    = num(okArr[i]?.valor);         // OK
        const noOk  = num(noOkArr[i]?.valor);       // NO OK
        const delta = ok + noOk - teo;              // (OK + NO OK) - Esperadas

        res.push({
          valor: delta,
          cavidad:   base.cavidad   || okArr[i]?.cavidad   || noOkArr[i]?.cavidad   || 'Cavidad',
          token:     base.token     || okArr[i]?.token     || noOkArr[i]?.token     || '',
          articulos: base.articulos || okArr[i]?.articulos || noOkArr[i]?.articulos || [],
        });
      }

      return res;
    },
    ladosNoOk() {
      const data = this.response || {};
      const agruparArt = (this.agruparPor || '').toLowerCase() === 'articulos';

      // --- V2 por cavidades (desde resumen) ---
      const cavRes = data?.resumen?.resumenCavidades?.cavidades || [];
      if (!agruparArt && Array.isArray(cavRes) && cavRes.length) {
        // Artículos por cavidad (tooltip) desde HORAS
        const horas = Array.isArray(data.horas) ? data.horas : [];
        const nombresPorCav = new Map();
        for (const h of horas) {
          for (const c of (h?.cavidades || [])) {
            const key = c?.idTokenExtra ?? 0;
            const set = nombresPorCav.get(key) || new Set();
            for (const a of (c?.articulos || [])) {
              const n = (a?.nombre ?? (this._nombreArticulo ? this._nombreArticulo(a?.idArticulo) : null))?.trim();
              if (n) set.add(n);
            }
            nombresPorCav.set(key, set);
          }
        }

        return cavRes.map(c => {
          const key = c?.idTokenExtra ?? 0;
          const nombres = Array.from(nombresPorCav.get(key) || []);
          const noOk = Number(c?.piezasNoOk) || 0;
          const okNet = Number(c?.piezasOk) || 0; // neto (OK − NoOK)
          const okBruto = okNet + noOk;              // ✅ OK sin descuento

          return {
            valor: noOk,
            okBruto,                                  // ✅ número pequeño
            cavidad: c?.cavidad || 'Cavidad',
            articulos: nombres,
            token: c?.cavidad || 'Cavidad',
          };
        });
      }

      // --- Fallback por HORAS ---
      const horas = Array.isArray(data.horas) ? data.horas : [];
      if (!horas.length) return [];

      if (agruparArt) {
        // Agrupar por ARTÍCULOS (atribuye a cada artículo del bloque horario)
        const ultArtPorCav = new Map(); // idCav -> [{idArticulo, nombre}]
        for (let i = horas.length - 1; i >= 0; i--) {
          const cavs = Array.isArray(horas[i]?.cavidades) ? horas[i].cavidades : [];
          for (const c of cavs) {
            const idCav = c?.idTokenExtra;
            if (idCav == null || ultArtPorCav.has(idCav)) continue;
            const arts = Array.isArray(c?.articulos) ? c.articulos : [];
            if (arts.length) {
              const pack = arts
                .map(a => ({
                  idArticulo: a?.idArticulo ?? a?.id,
                  nombre: a?.nombre ?? (this._nombreArticulo ? this._nombreArticulo(a?.idArticulo ?? a?.id) : null)
                }))
                .filter(x => x.idArticulo != null);
              if (pack.length) ultArtPorCav.set(idCav, pack);
            }
          }
        }

        const last = horas[horas.length - 1];
        const cavsLast = Array.isArray(last?.cavidades) ? last.cavidades : [];
        const porArticulo = new Map();

        for (const cav of cavsLast) {
          const okAcum = Number(cav?.piezasOkAcumulado ?? cav?.piezasOkHora ?? 0);
          const noOkAcum = Number(cav?.piezasNoOkAcumulado ?? cav?.piezasNoOkHora ?? 0);
          const okBrutoCav = okAcum + noOkAcum; // ✅ OK sin descuento

          // Artículos de la última hora; si no hay, fallback
          let arts = Array.isArray(cav?.articulos) ? cav.articulos : [];
          if (!arts.length) {
            const pack = ultArtPorCav.get(cav?.idTokenExtra) || [];
            arts = pack.map(p => ({ idArticulo: p.idArticulo, nombre: p.nombre }));
          }

          for (const a of arts) {
            const id = a?.idArticulo ?? a?.id;
            if (id == null) continue;

            const etiqueta = this._formatArtLabel(a);
            const prev = porArticulo.get(id) || { valor: 0, okBruto: 0, cavidad: etiqueta };

            porArticulo.set(id, {
              valor: prev.valor + (isNaN(noOkAcum) ? 0 : noOkAcum),        // NoOK (número grande)
              okBruto: prev.okBruto + (isNaN(okBrutoCav) ? 0 : okBrutoCav),// ✅ OK sin descuento (pequeño)
              cavidad: prev.cavidad || etiqueta
            });
          }
        }
        return Array.from(porArticulo.values());
      }

      // --- Agrupar por CAVIDAD desde HORAS ---
      const nombresPorCav = new Map();
      for (const h of horas) {
        const cavs = h?.cavidades || [];
        for (const c of cavs) {
          const set = nombresPorCav.get(c.idTokenExtra) || new Set();
          for (const a of (c.articulos || [])) {
            const nombre = (a?.nombre ?? (this._nombreArticulo ? this._nombreArticulo(a?.idArticulo) : null));
            const n = typeof nombre === 'string' ? nombre.trim() : null;
            if (n) set.add(n);
          }
          nombresPorCav.set(c.idTokenExtra, set);
        }
      }

      const last = horas[horas.length - 1];
      const cavsLast = Array.isArray(last?.cavidades) ? last.cavidades : [];

      return cavsLast.map(cav => {
        const nombres = Array.from(nombresPorCav.get(cav.idTokenExtra) || []);
        const noOkAcum = Number(
          cav?.piezasNoOkAcumulado ??
          cav?.piezasNoOkHora ??
          cav?.noOk ?? cav?.scrap ?? 0
        );
        const okAcum = Number(cav?.piezasOkAcumulado ?? cav?.piezasOkHora ?? 0);
        const okBruto = okAcum + noOkAcum; // ✅

        return {
          valor: isNaN(noOkAcum) ? 0 : noOkAcum,
          okBruto,                               // ✅ número pequeño
          cavidad: `${cav?.cavidad ?? 'Cavidad'}`,
          articulos: nombres,
          token: cav?.cavidad ?? 'Cavidad',
        };
      });
    },


    // === NUEVO: datos y headers para operacionesODT ===
    headersOperacionesODT() {
      if (!this._operacionesODT || !this._operacionesODT.length) return [];

      const sample = this._operacionesODT[0] || {};
      const allKeys = Object.keys(sample);

      const norm = s =>
        (s || '')
          .toString()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/([a-z])([A-Z])/g, '$1_$2')
          .toLowerCase();

      const used = new Set();

      const pick = (text, equals = [], includes = [], filterFn = null) => {
        // prioridad: coincidencia exacta (normalizada)
        for (const k of allKeys) {
          const nk = norm(k);
          if (equals.includes(nk) && !used.has(k) && (!filterFn || filterFn(nk))) {
            used.add(k);
            return { text, value: k };
          }
        }
        // fallback: contiene fragmentos
        for (const k of allKeys) {
          const nk = norm(k);
          if (includes.some(s => nk.includes(s)) && !used.has(k) && (!filterFn || filterFn(nk))) {
            used.add(k);
            return { text, value: k };
          }
        }
        return null;
      };

      const notFin = nk => !nk.includes('fin'); // evita confundir "inicio" con "fin"

      const headers = [
        // 1) ODT
        pick(
          'Clave ODT',
          ['clave_odt', 'odt_clave', 'claveodt', 'codigo_odt', 'odt_codigo'],
          ['clave', 'codigo', 'code', 'key'],
          nk => nk.includes('odt')
        ),
        // 2) Artículo
        pick(
          'Artículo',
          ['articulo', 'nombre_articulo', 'producto', 'sku'],
          ['articulo', 'producto', 'sku', 'item', 'nombre']
        ),
        // 3) Tiempo Ciclo (acepta variantes como tiempo_ciclo, tiempoMinXUnidad, etc.)
        pick(
          'Tiempo Ciclo',
          ['tiempo_ciclo', 'tiempo_ciclo_seg', 'cycle_time', 'tc'],
          ['tiempo_ciclo', 'tiempo', 'ciclo', 'cycle', 'tc', 'tiempo_min_x_unidad', 'tiempominxunidad']
        ),
        // 4) Inicio de primera operación registrada
        pick(
          'Inicio de primera operación registrada',
          ['inicio_primera_operacion_registrada', 'inicio_primera_operacion', 'fecha_inicio', 'hora_inicio'],
          ['inicio', 'fecha_inicio', 'hora_inicio', 'start', 'primera'],
          notFin
        ),
        // 5) Fin de última operación registrada
        pick(
          'Fin de última operación registrada',
          ['fin_ultima_operacion_registrada', 'fin_ultima_operacion', 'fecha_fin', 'hora_fin'],
          ['fin', 'fecha_fin', 'hora_fin', 'end', 'ultima']
        ),
        // 6) Piezas Reportadas (comúnmente "cantidad")
        pick(
          'Piezas Reportadas',
          ['piezas_reportadas', 'cantidad_reportada', 'piezas_totales', 'total_piezas', 'cantidad'],
          ['piezas', 'cantidad', 'reportad', 'total']
        ),
      ].filter(Boolean);

      return headers;
    },

    _operacionesODT() {
      const arr = this.response && Array.isArray(this.response.operacionesODT)
        ? this.response.operacionesODT
        : [];

      // Copia y formatea cualquier campo de inicio/fin: "YYYY-MM-DDTHH:mm:ss" -> "YYYY-MM-DD HH:mm:ss"
      return arr.map(it => {
        const out = { ...it };
        for (const k of Object.keys(out)) {
          const v = out[k];
          const lk = (k || '').toLowerCase();
          if (typeof v === 'string' && v.includes('T') && (lk.includes('inicio') || lk.includes('fin'))) {
            out[k] = v.replace('T', ' ');
          }
        }
        return out;
      });
    },
    areasTexto() {
      const arr = Array.isArray(this._operacionesODT) ? this._operacionesODT : [];
      const uniq = new Map(); // de-dup sensible (ignora mayúsculas/acentos), conserva el 1er formato visto

      const norm = s =>
        s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

      for (const it of arr) {
        const raw = (it?.nombreArea ?? '').toString().trim();
        if (!raw) continue;
        const key = norm(raw);
        if (!uniq.has(key)) uniq.set(key, raw);
      }

      const areas = Array.from(uniq.values());
      return areas.join(', ');
    },
    tcRealPromedioSegHora() {
      const rows = Array.isArray(this._rowsHora) ? this._rowsHora : [];
      const valores = [];

      for (const h of rows) {
        for (const c of (h.cavidades || [])) {
          // 1) Preferimos el valor directo en la cavidad
          let v = c?.tiempoCicloRealSegHora;

          // 2) Fallback: si no viene en cavidad, promedia los del arreglo de artículos (si existen)
          if ((v === null || v === undefined) && Array.isArray(c.articulos) && c.articulos.length) {
            const arr = c.articulos
              .map(a => Number(a?.tiempoCicloRealSegHora))
              .filter(n => Number.isFinite(n));
            if (arr.length) v = arr.reduce((s, n) => s + n, 0) / arr.length;
          }

          v = Number(v);
          if (Number.isFinite(v)) valores.push(v);
        }
      }

      if (!valores.length) return 0;
      return valores.reduce((s, n) => s + n, 0) / valores.length; // segundos por pieza
    },

    // opcional: texto para la tarjeta
    // tcRealPromedioSegHoraTxt() {
    //   return `${this.tcRealPromedioSegHora.toFixed(2)} s/pza`;
    // },
    tcRealPromedioSegHoraTxt() {
      const s = Number(this.tcRealPromedioSegHora); // seg/pza
      if (!Number.isFinite(s) || s <= 0) return '—';
      const pzh = 3600 / s; // pzas/h
      return `${this.nf(Math.round(pzh))} pza/h`;
    },
    tcRealPromedioPonderadoSegHora() {
    if (this.response?.tcReal?.segundos) {
      const tcSensor = Number(this.response.tcReal.segundos);
      if (Number.isFinite(tcSensor) && tcSensor > 0) {
        return tcSensor; 
      }
    }

    const rows = Array.isArray(this._rowsHora) ? this._rowsHora : [];
    let sumVW = 0;
    let sumW = 0;

    for (const h of rows) {
      for (const c of (h.cavidades || [])) {
        let v = c?.tiempoCicloRealSegHora;
        if ((v === null || v === undefined) && Array.isArray(c.articulos) && c.articulos.length) {
          const arr = c.articulos
            .map(a => Number(a?.tiempoCicloRealSegHora))
            .filter(n => Number.isFinite(n));
          if (arr.length) v = arr.reduce((s, n) => s + n, 0) / arr.length;
        }
        v = Number(v);
        if (!Number.isFinite(v)) continue;

          // Peso: producción de la hora (OK)
        let w = Number(c?.piezasOkHora ?? c?.ok ?? c?.piezasOk ?? 0);
        if (!Number.isFinite(w) || w < 0) w = 0;

        sumVW += v * w;
        sumW += w;
      }
    }
    return sumW ? (sumVW / sumW) : 0;
  },

    // tcRealPromedioPonderadoSegHoraTxt() {
    //   return `${this.tcRealPromedioPonderadoSegHora.toFixed(0)} s/pza`;
    // }
    tcRealPromedioPonderadoSegHoraTxt() {
      const s = Number(this.tcRealPromedioPonderadoSegHora); // seg/pza
      if (!Number.isFinite(s) || s <= 0) return '—';
      return `${s.toFixed(1)} seg/pza`; 
    },
  },
  methods: {
    verParos(tipo = 1){
      let c = this.conflineaParos;
      switch(tipo){
        case 1: // Todos
          c.verActivo = true;
          c.verProg = true;
          c.verNoProg = true;
        break;
        case 2: // Prog
          c.verActivo = true;
          c.verProg = true;
          c.verNoProg = false;
        break;
        case 3: // No Prog
          c.verActivo = true;
          c.verProg = false;
          c.verNoProg = true;
        break;
      }
      this.lineaParosTurno = true;
    },
    verNoOk(){
      this.piezasNoOkTurno = true;
    },
    // ⬇️ NUEVO: formateador para mostrar "[CÓDIGO] Nombre"
    _formatArtLabel(aOrId) {
      const build = (a) => {
        const cod = a?.codigo || a?.Codigo || a?.clave || a?.sku || "";
        const nom = a?.nombre || a?.descripcion || (a?.idArticulo ? `Artículo ${a.idArticulo}` : "");
        return cod ? `[${cod}] ${nom}` : nom;
      };
      if (aOrId && typeof aOrId === 'object') return build(aOrId);

      const id = Number(aOrId);
      for (const r of this._rowsHora) {
        for (const c of (r.cavidades || [])) {
          const a = (c.articulos || []).find(x => x.idArticulo === id);
          if (a) return build(a);
        }
      }
      if (this._nombresPorArticulo?.[id]) return this._nombresPorArticulo[id];
      return `Artículo ${id}`;
    },
    // Devuelve "[CÓDIGO] Nombre" con múltiples posibles campos de código
    _formatArtLabel(art) {
      const id = (art && typeof art === 'object')
        ? (art.idArticulo ?? art.id)
        : (typeof art === 'number' ? art : null);

      const nombre = (art && typeof art === 'object' && (art.nombre || art.descripcion))
        ? (art.nombre || art.descripcion)
        : this._nombreArticulo(id);

      // Prioriza: codigo, clave, sku, code
      const codigo = (art && typeof art === 'object')
        ? (art.codigo ?? art.clave ?? art.sku ?? art.code ?? null)
        : this._buscarCodigoArticulo(id);

      return codigo ? `[${codigo}] ${nombre || `Artículo ${id}`}` : (nombre || `Artículo ${id}`);
    },
     iniciarPollingTcReal() {
        // Actualizar cada 10 segundos
        this.intervalTcReal = setInterval(() => {
          if (this.filtros.idMaquinaIns && !this.loading) {
            this.obtenerTcRealParaResponse();
          }
        }, 10000);
      },
      
      detenerPollingTcReal() {
        if (this.intervalTcReal) {
          clearInterval(this.intervalTcReal);
          this.intervalTcReal = null;
        }
      },

    // Busca un código para un id de artículo escaneando las horas recibidas
    _buscarCodigoArticulo(idArt) {
      if (idArt == null) return null;
      for (const r of this._rowsHora) {
        for (const c of (r.cavidades || [])) {
          const a = (c.articulos || []).find(x => (x.idArticulo ?? x.id) === idArt);
          if (a) return a.codigo ?? a.clave ?? a.sku ?? a.code ?? null;
        }
      }
      return null;
    },


    nf(n) { return Number(n ?? 0).toLocaleString() },
    pf(n) { return `${Number(n ?? 0).toFixed(2)}%` },
    tfmt(seg = 0) {
      const s = Math.max(0, Math.floor(Number(seg) || 0));
      const hh = String(Math.floor(s / 3600)).padStart(2, '0');
      const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const ss = String(s % 60).padStart(2, '0');
      return `${hh} : ${mm} : ${ss}`;
    },
    _parHora(label) {
      const [desde, hasta] = (label || '').split(' - ').map(s => (s || '').trim());
      return { desde, hasta };
    },
    _nombreCavidad(idCav) {
      if (this._nombresPorCavidad?.[idCav]) return this._nombresPorCavidad[idCav];
      const row = this._rowsHora.find(r => (r.cavidades || []).some(c => c.idTokenExtra === idCav));
      if (!row) return `Cavidad ${idCav}`;
      const cav = (row.cavidades || []).find(c => c.idTokenExtra === idCav);
      return cav?.cavidad || `Cavidad ${idCav}`;
    },
    _nombreArticulo(idArt) {
      if (this._nombresPorArticulo?.[idArt]) return this._nombresPorArticulo[idArt];
      for (const r of this._rowsHora) {
        for (const c of (r.cavidades || [])) {
          const a = (c.articulos || []).find(x => x.idArticulo === idArt);
          if (a?.nombre) return a.nombre;
        }
      }
      return `Artículo ${idArt}`;
    },
    _sumEsperadasPorArticulo(rec, idArt, cavFilter = []) {
      // 1) Filtra cavidades por selección (si la hay)
      const cavsAll = (rec.cavidades || []).filter(c =>
        !cavFilter?.length || cavFilter.includes(c.idTokenExtra)
      );

      // 2) Si el artículo está presente en alguna cavidad de esta hora, usa solo esas;
      //    si NO está (caso de horas sin "articulos"), usa TODAS las cavidades del bloque.
      const cavsWithArt = cavsAll.filter(c =>
        (c.articulos || []).some(a => a.idArticulo === idArt)
      );

      const usar = cavsWithArt.length ? cavsWithArt : cavsAll;

      // 3) Suma teóricas del bloque horario (independiente de que haya "articulos")
      return usar.reduce((acc, c) => acc + Number(c.piezasTeoricasHora ?? 0), 0);
    },
    _sumEsperadasTotal(rec, cavFilter = []) {
      const cavs = (rec.cavidades || []).filter(c =>
        !cavFilter?.length || cavFilter.includes(c.idTokenExtra)
      );
      return cavs.reduce((acc, c) => acc + Number(c.piezasTeoricasHora ?? c.esperadas ?? c.teoricas ?? 0), 0);
    },

    noProgramadoParts() {
      var s = Math.max(0, Math.floor(this.response.resumen.segundosTiempoParo || 0))
      var d = Math.floor(s / 86400); s %= 86400
      var h = Math.floor(s / 3600); s %= 3600
      var m = Math.floor(s / 60); s %= 60
      var hh = h < 10 ? '0' + h : '' + h
      var mm = m < 10 ? '0' + m : '' + m
      var ss = s < 10 ? '0' + s : '' + s
      return { d: d || 0, h: hh || '00', m: mm || '00', s: ss || '00' }
    },
    partesDesdeSegundos(seg = 0) {
      let s = Math.max(0, Math.floor(Number(seg) || 0));
      const d = Math.floor(s / 86400); s %= 86400;
      const h = Math.floor(s / 3600); s %= 3600;
      const m = Math.floor(s / 60); s %= 60;
      const pad = n => (n < 10 ? '0' : '') + n;
      return { d, h: pad(h), m: pad(m), s: pad(s) };
    },
    programadoParts() {
      var s = Math.max(0, Math.floor(this.response.resumen.segundosTiempoParoProgramado || 0))
      var d = Math.floor(s / 86400); s %= 86400
      var h = Math.floor(s / 3600); s %= 3600
      var m = Math.floor(s / 60); s %= 60
      var hh = h < 10 ? '0' + h : '' + h
      var mm = m < 10 ? '0' + m : '' + m
      var ss = s < 10 ? '0' + s : '' + s
      return { d: d || 0, h: hh || '00', m: mm || '00', s: ss || '00' }
    },

    // IDs de cavidades a graficar (respeta filtro si existe)
    _getCavIds(rows, cavFilter = []) {
      const all = new Set();
      for (const r of (rows || [])) {
        for (const c of (r.cavidades || [])) all.add(c.idTokenExtra);
      }
      const ids = Array.from(all);
      return cavFilter?.length ? ids.filter(id => cavFilter.includes(id)) : ids;
    },

    // Devuelve el esperado EXACTO del JSON por cavidad y hora (sin sumar)
    // 1) Valor esperado por cavidad y hora (preferir TEÓRICAS reales)
    _esporCavidad(rec, cavId) {
      const cav = (rec?.cavidades || []).find(c => c.idTokenExtra === cavId);
      if (!cav) return null;

      const v =
        cav?.piezasTeoricasHora ??        // ✅ principal (lo que cambia con paros)
        cav?.teoricasHora ??
        cav?.esperadasHora ??
        cav?.piezasEsperadasTeoricasHora ?? // fallback
        cav?.piezasRateHora ??              // último recurso
        null;

      return v == null ? null : Number(v);
    },

    // 2) Serie de ESPERADAS por CAVIDAD (línea)
    _makeEsperadasSeriesPorCavidad(horas, rows, cavFilter = []) {
      const cavIds = this._getCavIds(rows, cavFilter);
      return cavIds.map((cavId) => ({
        name: `Esperadas ${this._nombreCavidad(cavId)}`,
        type: 'line',
        data: (horas || []).map(label => {
          const { desde, hasta } = this._parHora(label);
          const rec = rows.find(r =>
            (r.desdeHora ?? r.horaInicio) === desde &&
            (r.hastaHora ?? r.horaFin) === hasta
          );
          return rec ? this._esporCavidad(rec, cavId) : null;
        }),
      }));
    },
    _makeEsperadasSeriesPorArticulo(horas, rows, cavFilter = []) {
      const arts = this._articulosSerie;

      // idArticulo -> Set(cavidades donde apareció alguna vez)
      const basesPorArt = new Map();
      for (const r of rows) {
        for (const c of (r.cavidades || [])) {
          for (const a of (c.articulos || [])) {
            const idArt = a?.idArticulo;
            if (idArt == null) continue;
            const set = basesPorArt.get(idArt) || new Set();
            set.add(c.idTokenExtra);
            basesPorArt.set(idArt, set);
          }
        }
      }

      // Teóricas por hora: prioriza piezasTeoricasHora; si no viene, cae a esperadas/rate
      const teoh = (c) => Number(
        c?.piezasTeoricasHora ??
        c?.teoricasHora ??
        c?.esperadasHora ??
        c?.piezasEsperadasTeoricasHora ??
        c?.piezasRateHora ?? 0
      ) || 0;

      const cavEnFiltro = (id) =>
        !Array.isArray(cavFilter) || !cavFilter.length || cavFilter.includes(id);

      return arts.map((idArt, idx) => ({
        name: `Esperadas ${this._nombreArticulo(idArt)}`,
        type: 'line',
        data: (horas || []).map(label => {
          const { desde, hasta } = this._parHora(label);
          const rec = rows.find(r =>
            (r.desdeHora ?? r.horaInicio) === desde &&
            (r.hastaHora ?? r.horaFin) === hasta
          );
          if (!rec) return 0;

          const cavs = rec.cavidades || [];

          // 1) Si esta hora trae 'articulos', sumar solo cavidades que traen ese artículo
          const cavsConArt = cavs.filter(c =>
            cavEnFiltro(c.idTokenExtra) &&
            (c.articulos || []).some(a => a.idArticulo === idArt)
          );
          if (cavsConArt.length) return cavsConArt.reduce((s, c) => s + teoh(c), 0);

          // 2) Fallback: no vino 'articulos' → sumar TODAS las cavidades base conocidas del artículo
          const baseSet = basesPorArt.get(idArt);
          if (baseSet && baseSet.size) {
            let sum = 0;
            for (const baseId of baseSet) {
              if (!cavEnFiltro(baseId)) continue;
              const cavBase = cavs.find(c => c.idTokenExtra === baseId);
              if (cavBase) sum += teoh(cavBase);
            }
            return sum;
          }

          return 0;
        }),
        color: this.paletteLines[idx % this.paletteLines.length],
      }));
    },

    // === NUEVO: series para RATE ===
    _makeRateSeriesPorCavidad(horas, rows, cavFilter = []) {
      const cavIds = this._getCavIds(rows, cavFilter);
      return cavIds.map((cavId, idx) => ({
        name: `Rate ${this._nombreCavidad(cavId)}`,
        type: 'line',
        data: horas.map(label => {
          const { desde, hasta } = this._parHora(label);
          const rec = rows.find(r =>
            (r.desdeHora ?? r.horaInicio) === desde &&
            (r.hastaHora ?? r.horaFin) === hasta
          );
          if (!rec) return null;
          const cav = (rec.cavidades || []).find(c => c.idTokenExtra === cavId);
          if (!cav) return null;
          const v = cav?.piezasRateHora;
          return (v === null || v === undefined) ? null : Number(v);
        }),
      }));
    },
    _makeRateSeriesPorArticulo(horas, rows, cavFilter = []) {
      const arts = this._articulosSerie;

      // Mapa: idArticulo -> Set de TODAS las cavidades donde apareció alguna vez
      const basesPorArt = new Map();
      for (const r of rows) {
        for (const c of (r.cavidades || [])) {
          for (const a of (c.articulos || [])) {
            const idArt = a?.idArticulo;
            if (idArt == null) continue;
            const set = basesPorArt.get(idArt) || new Set();
            set.add(c.idTokenExtra);
            basesPorArt.set(idArt, set);
          }
        }
      }

      // helpers
      const rateh = (c) => Number(
        c?.piezasRateHora ?? c?.rateHora ?? c?.rate ?? c?.pzasHora ?? 0
      ) || 0;
      const cavEnFiltro = (id) =>
        !Array.isArray(cavFilter) || !cavFilter.length || cavFilter.includes(id);

      return arts.map((idArt, idx) => ({
        name: `Rate ${this._nombreArticulo(idArt)}`,
        type: 'line',
        data: (horas || []).map(label => {
          const { desde, hasta } = this._parHora(label);
          const rec = rows.find(r =>
            (r.desdeHora ?? r.horaInicio) === desde &&
            (r.hastaHora ?? r.horaFin) === hasta
          );
          if (!rec) return 0;

          const cavs = rec.cavidades || [];

          // 1) Si en esta hora vienen los artículos, suma las cavidades que lo traen
          const cavsConArt = cavs.filter(c =>
            cavEnFiltro(c.idTokenExtra) &&
            (c.articulos || []).some(a => a.idArticulo === idArt)
          );
          if (cavsConArt.length) {
            return cavsConArt.reduce((s, c) => s + rateh(c), 0);
          }

          // 2) Fallback: no vino 'articulos' en la hora → sumar TODAS las cavidades base conocidas
          const baseSet = basesPorArt.get(idArt);
          if (baseSet && baseSet.size) {
            let sum = 0;
            for (const baseId of baseSet) {
              if (!cavEnFiltro(baseId)) continue;
              const cavBase = cavs.find(c => c.idTokenExtra === baseId);
              if (cavBase) sum += rateh(cavBase);
            }
            return sum;
          }

          return 0;
        }),
        color: this.paletteLines[idx % this.paletteLines.length],
      }));
    },
    _rehideEsperadas() {
      this.$nextTick(() => {
        const comp = this.$refs.hhChart;
        // wrapper vue-apexcharts expone hideSeries/toggleSeries
        const hide = name => {
          if (comp?.hideSeries) comp.hideSeries(name);
          else if (comp?.toggleSeries) comp.toggleSeries(name);
        };

        // intenta leer los nombres desde la instancia interna
        const chart = comp?.chart;
        const names = chart?.w?.globals?.seriesNames || [];

        names.forEach(n => {
          if (typeof n === 'string' && n.toLowerCase().startsWith('esperadas')) {
            hide(n);
          }
        });
      });
    },
  },
  watch: {
    agruparPor() {
      if (this.esperadasInicianOcultas) this._rehideEsperadas();
    },
    horaHoraSeries() {
      if (this.esperadasInicianOcultas) this._rehideEsperadas();
    }
  },
}
</script>

<style scoped>
.v-list-item__subtitle {
  font-size: 12px;
}

.v-list-item__title {
  font-weight: 600;
}

.apexcharts-canvas {
  max-width: 100%;
}

.kpi-row .v-card {
  border-radius: 10px;
}

.kpi-title {
  /* font-weight: 800 !important; */
  letter-spacing: .3px !important;
  font-size: 14px !important;
}

.kpi-number {
  font-size: 34px;
  line-height: 1;
  font-weight: 800;
}

.kpi-sub {
  font-size: 11px;
  letter-spacing: .4px;
  color: #78909C;
}

.kpi-blue {
  color: #1976D2;
}

.kpi-teal {
  color: #2E7D32;
}

.kpi-green {
  color: #26A69A;
}

.kpi-red {
  color: #E53935;
}

.kpi-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kpi-icon-blue {
  background: #E8F2FF;
}

.kpi-icon-teal {
  background: #C8E6C9;
}

.kpi-icon-mint {
  background: #EAF8F1;
}

.kpi-icon-soft-red {
  background: #fdecec;
}

.kpi-tile {
  width: 100%;
}

.clickable-card {
  cursor: pointer;
  transition: all 0.2s ease;
}

.clickable-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}

.areas-text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17.5px;
  letter-spacing: .2px;
  color: #546E7A;
  /* gris azulado suave */
  font-weight: 600;
  /* semibold para resaltar sin ser pesado */
}

.three-cols {
  display: grid;
  grid-template-columns: 1.2fr 1fr .6fr;
  column-gap: 16px;
  align-items: center;
}

@media (max-width:960px) {
  .three-cols {
    grid-template-columns: 1fr 1fr;
    row-gap: 4px;
  }

  .three-cols> :nth-child(3) {
    grid-column: 1 / -1;
    text-align: left;
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.pulse-icon {
  animation: pulse 2s ease-in-out infinite;
}

.areas-text {
  font-size: 0.95rem !important;
  font-weight: 600;
  color: #666;
  letter-spacing: 0.02em;
}

.no-split {
  white-space: nowrap;
}

.kpi-suffix {
  font-size: 16px;
  /* más pequeño que .kpi-number (34px) */
  line-height: 1.1;
  font-weight: 700;
  margin-left: 6px;
  /* un pequeño espacio luego del 10 */
}

.no-split {
  word-break: keep-all;
  /* evita cortes dentro de las palabras */
  overflow-wrap: normal;
  /* solo rompe en espacios */
  hyphens: none;
  /* sin guiones automáticos */
}
</style>